// extracted by mini-css-extract-plugin
export default {"no-of-results":"list-renderer__no-of-results--q8WG1","noOfResults":"list-renderer__no-of-results--q8WG1"};